/** Fixed Gaia SECR source keys — keep in sync with backend secrSourceMapping.SECR_SOURCE_KEYS */
export const SECR_REPORTING_SOURCE_OPTIONS: { key: string; label: string }[] = [
  { key: 'electricity', label: 'Electricity' },
  { key: 'natural_gas', label: 'Natural gas' },
  { key: 'diesel', label: 'Diesel' },
  { key: 'petrol', label: 'Petrol' },
  { key: 'lpg', label: 'LPG' },
  { key: 'purchased_heat', label: 'Purchased heat' },
  { key: 'purchased_steam', label: 'Purchased steam' },
  { key: 'purchased_cooling', label: 'Purchased cooling' },
  { key: 'other_fuel', label: 'Other fuel' },
  { key: 'other_energy', label: 'Other energy' },
  { key: 'unmapped', label: 'Other / not yet classified' },
];

export function secrSourceLabelForKey(key: string | null | undefined): string {
  if (key == null || key === '') return '—';
  const o = SECR_REPORTING_SOURCE_OPTIONS.find((x) => x.key === key);
  return o?.label ?? key;
}
